export default __webpack_public_path__ + "static/media/bmb-2-m.deb92db1.png";